const query_country = catalogModule.getQueryCountry();
const query_country_name = catalogModule.getQueryCountryName();
const userAddonsUrl = catalogModule.getUrl("user_addons");
const bundleViewUrl = catalogModule.getUrl("bundle_view");
const staticNaProductUrl = catalogModule.getUrl("static_na_product");
import SkeletonLoader from "./skeleton_loader";
import ImageLoader from "./image_loader";
const preferredText = gettext("People buying this product are also buying:");
const staticFeature = catalogModule.getUrl("static_feature");
const featuredLimit = 6;

const PreferredProducts = (props) => {
    const [featuresList, setFeaturesList] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    React.useEffect(() => {
        setIsLoading(true)
        getFeatureAddons();
    }, []);

    async function getFeatureAddons(){
        let results = await catalogModule.getDisplayAddons(props.product.key);
        if(results){
            setFeaturesList(results);
            setIsLoading(false)
        }
    }
    let renderFeatures = featuresList.length > 0 && featuresList.map((product, index) => {
        if(index < featuredLimit){
            let urlParams;
            if(product.key.includes('xample.group')){
                urlParams =  `${userAddonsUrl}?country=${query_country}`;
            } else {
                urlParams = `${bundleViewUrl}?key=${product.key}&country=${query_country}&country_name=${query_country_name}`;
            }
            let imgThumbnail;
            if(product.thumbnailURL){
                imgThumbnail = product.thumbnailURL;
            } else if (product.thumbnailurl){
                imgThumbnail = product.thumbnailurl;
            } else {
                imgThumbnail = staticNaProductUrl
            }

            return (
                <div className="col" key={product.key}>
                    <a onClick={(e) => show_spinner(e, null, urlParams)}>
                        <div className="product_card">
                            <ImageLoader src={imgThumbnail}
                                         alt={product.name}
                                         skelWidth={'100%'}
                                         skelHeight={'215px'}
                                         imgClass="img-fluid" />
                            {/*<img src={imgThumbnail} alt={product.name} className="img-fluid" />*/}
                            { (product.featured || product.featured === 0) && <img className="product_card_feature" src={staticFeature} alt="featured_product"/> }
                            <div className="footer-slider-item-caption text-center">
                                <p>{product.name}</p>
                            </div>
                        </div>
                    </a>
                </div>
            )
        }
    });
    let renderLoader = <React.Fragment>
        <div className="col">
            <SkeletonLoader width={'100%'} height={'215px'} />
        </div>
        <div className="col">
            <SkeletonLoader width={'100%'} height={'215px'} />
        </div>
        <div className="col">
            <SkeletonLoader width={'100%'} height={'215px'} />
        </div>
        <div className="col">
            <SkeletonLoader width={'100%'} height={'215px'} />
        </div>
        <div className="col">
            <SkeletonLoader width={'100%'} height={'215px'} />
        </div>
        <div className="col">
            <SkeletonLoader width={'100%'} height={'215px'} />
        </div>
    </React.Fragment>
    return (
        <div className="preferred_products">
            <div className="product_prefered_header text-center">
                <h3>{preferredText}</h3>
            </div>
            <div className="list_preferred_products">
                <div className="row justify-content-center gap-3 flex-wrap">
                    {!isLoading && renderFeatures}
                    {isLoading && renderLoader}
                </div>
            </div>
        </div>
    )
}

export default PreferredProducts;
